import { createGlobalStyle } from "styled-components"

export default createGlobalStyle`
body {
  font-family: sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--bg);
  color: var(--textNormal);
  &.dark {
    --bg: #252832;
    --textNormal: #D7DDDB;
    --textInverse: #000;
    --textTitle: #d8d8d8;
    --textTitleInverse: #000;
    --link: #849991;
  }
  &.light {
    --bg: #cacecf;
    --textNormal: #081C15;
    --textInverse: #fff;
    --textTitle: #303030;
    --textTitleInverse: #dbdbdc;
    --link: #849991;
  }
  h1,
  h2,
  h3,
  h4 {
    color: var(--textTitle);
  }
  input,
  textarea,
  button,
  select,
  a {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  a {
  color: var(--link);

  }
  img {
    padding: 0;
    margin: 0;
    user-select: none;
  }
}`
